var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProdt = function SvgProdt(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.92 10.42a4.42 4.42 0 1 1-8.84 0 4.42 4.42 0 0 1 8.84 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 15s-4.02 4.06-4.46 9.12a.83.83 0 0 0 .84.88h2.79A7.09 7.09 0 0 1 18 16.5c.94 0 1.83.19 2.63.52C19.75 15.76 19 15 19 15s-1.5 1.36-3.5 1.36S12 15 12 15zm6.03 3.5c-1.44 0-2.88.6-3.89 1.82-.24.3-.07.72.3.81l3.49.94c.1.03.2.03.3 0l3.36-.9c.37-.1.54-.52.3-.81a4.97 4.97 0 0 0-3.86-1.86zm-4.43 3.87a.51.51 0 0 0-.55.44c-.1.7 0 1.5.2 2.19h4.03l.02-.55c0-.15-.07-.3-.15-.42a1 1 0 0 1-.15-.53c0-.12-.07-.25-.2-.28l-3.09-.83a.57.57 0 0 0-.11-.02zm8.8.04a.6.6 0 0 0-.11.02l-3.13.84c-.1.03-.16.13-.16.23a1 1 0 0 1-.15.53.82.82 0 0 0-.15.42V25h3.92a.83.83 0 0 0 .15-.01c.2-.68.28-1.45.2-2.14-.04-.28-.3-.45-.56-.44z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProdt);
export default ForwardRef;